import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, GuardsCheckEnd } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { LinkItem, isDefined } from '@slb-dls/angular-material/shared';
import { SlbNotificationItem, } from '@slb-dls/angular-material/notifications-panel';
import { PageTitleService } from './page-title.service';
import { AppConfigService } from './app-config.service';
import { Navigation, NavigationFacade, NavigationItem } from '@ct-software/ct-ui-core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AppComponent implements OnDestroy {
  showHeader: boolean = false;
  pageTitle: string = '';

  public navigation$: Observable<Navigation>;

  private routerSubscription = Subscription.EMPTY;

  private sideNav: NavigationItem[] = [
    {
      id: 'dashboard',
      title: 'Dashboard',
      icon: 'dashboard-1',
      url: 'dashboard/Dashboard'
    },
    {
      id: 'wells',
      title: 'Wells',
      icon: 'rig',
      url: 'dashboard/ByWells'
    },
    {
      id: 'acquisitions',
      title: 'Acquisitions',
      icon: 'add-to-datasource',
      url: 'dashboard/byUploads'
    },
    {
      id: 'designs',
      title: 'Designs',
      icon: 'add-to-datasource',
      url: 'dashboard/byDesigns'
    },
    {
      id: 'coilscan',
      title: 'CoilScan',
      icon: 'viewer',
      url: 'dashboard/CoilScan'
    },
    {
      id: 'analytics',
      title: 'Analytics',
      icon: 'notes',
      url: 'dashboard/SandBox'
    },
  ];

  constructor(
    public readonly router: Router,
    private readonly pageTitleService: PageTitleService,
    private readonly navigationFacade: NavigationFacade,
    matIconRegistry: MatIconRegistry,
    domSanitizer: DomSanitizer,
    appConfigService: AppConfigService
  ) {
    matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/svg-symbols.svg'));

    if (!appConfigService.coilScanReportId) {
      const coilScanPage = this.sideNav.filter(x => x.title === 'CoilScan')[0];
      this.sideNav.splice(this.sideNav.indexOf(coilScanPage), 1);
    }

    this.routerSubscription = router.events.pipe(
      filter(e => e instanceof GuardsCheckEnd),
      map(e => e as GuardsCheckEnd))
      .subscribe(e => this.onRouteChange(e));

    this.pageTitleService.pageTitleChanged.subscribe(x => this.pageTitle = x);

  }

  ngOnInit() {
    this.moveHomeButton();
    this.setNavigation(true);
    this.navigation$ = this.navigationFacade.navigation$;
  }

  private setNavigation(hasSidenav: boolean): void {
    this.navigationFacade.setNavigation(hasSidenav ? {
      hasSidenav: true,
      items: this.sideNav
    }: { hasSidenav: false, items: [] });
  }


  private moveHomeButton() {
    let button = document.getElementById('homeButton');
    let applicationTitle = document.getElementsByClassName('dls-application-title')[0];
    if (!button || !applicationTitle) {
      setTimeout(this.moveHomeButton, 10);
      return;
    }

    applicationTitle.insertBefore(button, applicationTitle.firstChild);
    const logo = applicationTitle.getElementsByClassName('dls-application-logo-container')[0];
    if (logo) {
      logo.parentNode.removeChild(logo);
    }
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }

  private onRouteChange(event: GuardsCheckEnd): void {
    if (!event.shouldActivate) {
      return;
    }

    const data = event.state.root.firstChild.data;
    this.showHeader = isDefined(data.showHeader) ? data.showHeader : true;

    if (data.title) {
      this.pageTitle = data.title;
    }

    this.setNavigation(data.hasSideNav === false ? false : true);
  }

  getUrl(currentUrl: string, urlLevel: number, newPart: string) {
    let parts = currentUrl.split('/').slice(0, urlLevel + 1);
    parts.push(newPart);
    return parts.join('/');
  }
}
